import { REQUEST_STATUS } from '@shared/constants/otherConstants';
import ModalErrorContainer from '@shared/components/modals/ModalErrorContainer';
import {
    cancelBookingReset,
    createBookingReset,
    getBookingDevicesLocationsReset,
    getBookingDevicesReset,
    getBookingsReset,
    updateBookingReset,
} from '../store';
import {
    selectCancelBookingErrorInfo,
    selectCancelBookingStatus,
    selectCreateBookingErrorInfo,
    selectCreateBookingStatus,
    selectGetBookingDevicesErrorInfo,
    selectGetBookingDevicesLocationsErrorInfo,
    selectGetBookingDevicesLocationsStatus,
    selectGetBookingDevicesStatus,
    selectGetBookingsErrorInfo,
    selectGetBookingsStatus,
    selectUpdateBookingErrorInfo,
    selectUpdateBookingStatus,
} from '../store/selectors';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const BookingCalendarErrorHandlers = () => {
    const { t } = useTranslation();
    const getBookingsStatus = useSelector(selectGetBookingsStatus);
    const getDevicesStatus = useSelector(selectGetBookingDevicesStatus);
    const getDevicesLocationsStatus = useSelector(selectGetBookingDevicesLocationsStatus);
    const createBookingStatus = useSelector(selectCreateBookingStatus);
    const updateBookingStatus = useSelector(selectUpdateBookingStatus);
    const cancelBookingStatus = useSelector(selectCancelBookingStatus);

    return (
        <>
            {getDevicesStatus === REQUEST_STATUS.ERROR && (
                <ModalErrorContainer
                    object={t('devices_r')}
                    action={t('fetching')}
                    resetActionCallback={getBookingDevicesReset}
                    errorSelector={selectGetBookingDevicesErrorInfo}
                />
            )}
            {getDevicesLocationsStatus === REQUEST_STATUS.ERROR && (
                <ModalErrorContainer
                    object={t('locations_r')}
                    action={t('fetching')}
                    resetActionCallback={getBookingDevicesLocationsReset}
                    errorSelector={selectGetBookingDevicesLocationsErrorInfo}
                />
            )}
            {createBookingStatus === REQUEST_STATUS.ERROR && (
                <ModalErrorContainer
                    object={t('booking_r')}
                    action={t('creating')}
                    resetActionCallback={createBookingReset}
                    errorSelector={selectCreateBookingErrorInfo}
                />
            )}
            {updateBookingStatus === REQUEST_STATUS.ERROR && (
                <ModalErrorContainer
                    object={t('booking_r')}
                    action={t('saving')}
                    resetActionCallback={updateBookingReset}
                    errorSelector={selectUpdateBookingErrorInfo}
                />
            )}
            {cancelBookingStatus === REQUEST_STATUS.ERROR && (
                <ModalErrorContainer
                    object={t('booking_r')}
                    action={t('cancelling')}
                    resetActionCallback={cancelBookingReset}
                    errorSelector={selectCancelBookingErrorInfo}
                />
            )}
            {getBookingsStatus === REQUEST_STATUS.ERROR && (
                <ModalErrorContainer
                    object={t('bookings_r')}
                    action={t('fetching')}
                    resetActionCallback={getBookingsReset}
                    errorSelector={selectGetBookingsErrorInfo}
                />
            )}
        </>
    );
};

export default BookingCalendarErrorHandlers;
